import type { Language, Translation } from '../types/i18n'
import { fr } from './translations/fr'
import { es } from './translations/es'
import { en } from './translations/en'

export const languageShort: Record<Language, string> = {
  fr: 'FR',
  es: 'ES',
  en: 'EN',
}

export const translations: Record<Language, Translation> = {
  fr,
  es,
  en,
}
